import { Outlet, createFileRoute } from "@tanstack/react-router";

import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.PRP_SCRIPT)({
    component: PrpScriptLayout,
    staticData: {
        config: {
            breadcrumb: {
                title: "PRP Skript",
                to: APP_ROUTES_TO.PRP_SCRIPT,
            },
            title: "PRP Skript",
        },
    },
});

function PrpScriptLayout() {
    return <Outlet />;
}
